import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ple-footer',
  templateUrl: './ple-footer.component.html',
  styleUrls: ['./ple-footer.component.scss']
})
export class PleFooterComponent implements OnInit {

  copyright: string;
  constructor() { }

  ngOnInit(): void {
    this.copyright = `©${new Date().getFullYear()} Baker Hughes Company`;
  }

}
